module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-08-b6e86bb429381637ab9c35d9c516e43d.jpg";